import { Box, Button, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import { getInvoice, getTopInvoice } from "./invoice_halper";
import InvoiceList from "./invoice_list";
import { getClientList } from "../booking/booking_halper";
import { dateUsaToInd, getCurrentDate, getCurrentMonthStart } from "../frames/common";
import { useNavigate } from "react-router-dom";
import TrayItem from "../frames/tray_item";

const cu_date = getCurrentDate();

function Invoices() {
    const [clients, setClients] = useState(null);
    const [clientList, setClientList] = useState(null);
    const [topInvoice, setTopInvoice] = useState(null);
    const [maxCompany, setMaxCompany] = useState(4);

    const [spanTime, setSpanTime] = useState('month');
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const navigator = useNavigate();

    function __get_invoice_by_span(span) {
        getInvoice(span, "", "").then((res) => {
            setTopInvoice(res);
            setIsLoading(false);
        }).catch((err) => {
            setTopInvoice([]);
            setIsLoading(false);
            console.error(err);
        });
    }

    const initData = async (auth) => {
        if (!auth) return;
        try {
            const clts = await getClientList("billing");
            for (let idx = 0; idx < clts.length; idx++) {
                clts[idx]["description"] = clts[idx]["client_id"];
                clts[idx]["caption"] = clts[idx]["gst_num"];
                clts[idx]["link"] = clts[idx]["client_id"];
            }
            setClientList(clts);
            setClients(clts);
        } catch (error) {
            setClientList([]);
            setClients([]);
            console.error(error);
        }
        try {
            setTopInvoice(await getTopInvoice());
        } catch (error) {
            setTopInvoice([]);
            console.error(error);
        }
    }

    const handleTimeChange = (e, start) => {
        if (e.target.value === "") return;
        setSpanTime("");
        let start_ = startTime;
        let end_ = endTime;
        const n_date = dateUsaToInd(e.target.value);
        if (start) {
            start_ = n_date;
            setStartTime(n_date);
        } else {
            end_ = n_date;
            setEndTime(n_date);
        }
        if (start_ === "") { start_ = dateUsaToInd(getCurrentMonthStart()); }
        if (end_ === "") { end_ = dateUsaToInd(cu_date); }
        setIsLoading(true);
        getInvoice("", start_, end_).then((res) => {
            setTopInvoice(res);
            setIsLoading(false);
        }).catch((err) => {
            setTopInvoice([]);
            setIsLoading(false);
            console.error(err);
        });

    }

    const handleSpanChange = (e) => {
        setSpanTime(e.target.value);
        if (e.target.value === "") return;
        setStartTime("");
        setEndTime("");
        setIsLoading(true);
        __get_invoice_by_span(e.target.value);
    }

    const handleSearch = (e) => {
        const txt = e.target.value.trim().toLowerCase();
        if (txt === "") setClientList(clients);
        setClientList(clients.filter((i) => i.name.toLowerCase().includes(txt) || i.client_id.toLowerCase().includes(txt)));
    }

    return (
        <MenuFrame onSearch={handleSearch} permission="BILLING_ORG" onInit={initData} screen={"INVOICE"}>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <TrayItem items={clientList && maxCompany ? clientList.slice(0, Math.min(maxCompany, clientList.length)) : clientList} showicon={false} />
            {!maxCompany ? "" :
                <Box sx={{ display: "flex", justifyContent: "center", cursor: "pointer", mb: 3, mt: 1 }} onClick={() => { setMaxCompany(0); }}>
                    <Box sx={{ boxShadow: "0 0 20px 1px #607D8B", width: "calc(100% - 20px)", borderRadius: 5, textAlign: "center", py: 1, backgroundColor: "background.paper", color: "text.primary" }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>More Company</Typography>
                    </Box>
                </Box>
            }
            <Box sx={{ mt: 2, mb: 2 }}>
                <Button fullWidth onClick={() => { navigator("/daybooking"); }} variant="outlined" color="info" sx={{ textTransform: "none", borderRadius: 10 }}>Day Booking</Button>
            </Box>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth>
                        <InputLabel id="time-span">Span</InputLabel>
                        <Select
                            labelId="time-span"
                            id="time-span"
                            label="Time Span"
                            value={spanTime}
                            onChange={handleSpanChange}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"day"}>Day</MenuItem>
                            <MenuItem value={"month"}>Month</MenuItem>
                            <MenuItem value={"last-month"}>Last Month</MenuItem>
                            <MenuItem value={"unpaid"}>Unpaid</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="start_date" type="date" fullWidth defaultValue={getCurrentMonthStart()} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="Start Date" onChange={(e) => { handleTimeChange(e, true) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="end_date" type="date" fullWidth defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="End Date" onChange={(e) => { handleTimeChange(e, false) }} />
                </Grid>
            </Grid>
            <InvoiceList invoice={topInvoice} />
        </MenuFrame>
    );
}

export default Invoices;